import { render } from "./TheThanhTichCaNhanTheThao.vue?vue&type=template&id=6b5fde6a"
import script from "./TheThanhTichCaNhanTheThao.vue?vue&type=script&lang=js"
export * from "./TheThanhTichCaNhanTheThao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__